// extracted by mini-css-extract-plugin
module.exports = {"sidebarContainerCard":"UserPropCard_sidebarContainerCard__1WzP5","userPropCard":"UserPropCard_userPropCard__3HQqp"};